var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9e3da24f1b69594babf10f57f474ebfdc2c62ca9"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["keune@ask-phill"]={id:"9e3da24f1b69594babf10f57f474ebfdc2c62ca9"};
      